import { TraitRegistryCategory } from '../TraitRegistryCategory';
import { TraitTypeSelectWithPreview } from '../traitTypes/TraitTypeSelectWithPreview';
export class TraitRegistryCssTable extends TraitRegistryCategory {
    label = 'Tabelle';
    constructor(parent) {
        super(parent);
        super.init();
    }
    align = () => new TraitTypeSelectWithPreview({
        default: 'left',
        label: 'Align',
        init: 'center',
        select: [['left'], ['right'], ['center'], ['justify'], ['char']]
    });
    valign = () => new TraitTypeSelectWithPreview({
        default: 'top',
        label: 'Valign',
        init: 'middle',
        select: [['top'], ['middle'], ['bottom'], ['baseline']]
    });
}
